export const validateUrl = (string: string): boolean => {
    let url;

    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }

    const hasTld = /\.[a-z]{2,}$/i.test(url.hostname);

    return (url.protocol === 'http:' || url.protocol === 'https:') && hasTld;
};
